import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { useTheme } from 'foundations-theming/utils';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import ApiError from '../Errors/ApiError';
import { SkeletonBlock } from '../Skeletons/subcomponents/Skeleton';
import SectionHeading from '../SectionHeading';
import CardsSection from '../../features/cardsSection/components/CardsSection';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RecommendationsSkeleton = ({
  error
}) => {
  const {
    isMobile,
    isTablet
  } = useMediaQuery();
  const theme = useTheme();
  return /*#__PURE__*/_jsxs(View, {
    "data-test-id": "recommendations-skeleton",
    marginBlockStart: isMobile ? '500' : '900',
    children: [/*#__PURE__*/_jsx(SectionHeading, {
      subText: /*#__PURE__*/_jsx(View, {
        marginBlockStart: "200",
        children: /*#__PURE__*/_jsx(SkeletonBlock, {
          height: theme.space['400'],
          width: "30%"
        })
      }),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.tracks.headers.recommended"
      })
    }), error ? /*#__PURE__*/_jsx(ApiError, {
      error: error
    }) : /*#__PURE__*/_jsx(CardsSection, {
      isLoading: true,
      size: isTablet ? 'small' : 'large'
    })]
  });
};
export default RecommendationsSkeleton;